import './mobile-nav.component.js';
import './mobile-nav.controller.js';
import './nav.component.js';
import './nav.controller.js';
import './_nav.styles.scss';
import './_mobile-menu.styles.scss';

angular
.module('inkfinder')
.config(function($stateProvider, USER_ROLES) {
  $stateProvider
  .state('inkfinder', {
    abstract: true,
    views: {
      'navigation@': {
        component: 'inkNav'
      },
      'stats-shelf@': {
        component: 'inkStatsShelf'
      },
      'mobile-navigation@': {
        component: 'inkMobileNav'
      }
    },
    onEnter: function(Events) {
      Events.navActive = true;
    },
    onExit: function(Events) {
      Events.navActive = false;
    },
    // Resolve for a new messages count in the message center
    resolve: {
      participants: function(Participants, Events) {
        Participants.getUnreadCount().then(function(count) {
          Events.newMessagesCount = count;
        });
      }
    },
    data: {
      authorizedRoles: [USER_ROLES.collector, USER_ROLES.artist,
      USER_ROLES.operator]
    }
  });
});



// WEBPACK FOOTER //
// ./common/nav/index.js